import styled from "styled-components";

import { themeColors } from "../../react/sharedStyles";

import React, { Component } from "react";
import { IconButton } from "../../Components/IconButton";
import { FlexSpacer } from "../../react/components/Gap";
import PresentationEditorController from "../PresentationEditor/PresentationEditorController";

const StyledPropertyPanelHeader = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0px 5px 0px 15px;
    background: ${props => props.isChildElement ? themeColors.darkBlue : "white"};
    color: ${props => props.isChildElement ? "white" : "#333"};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    text-wrap: nowrap;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 0;
    cursor: default;

    .drop-down-arrow {
        .bai-icon {
            color: white !important;
        }
    }
`;

export class PropertyPanelHeader extends Component {
    handleClose = () => {
        const { callback } = this.props;

        if (callback) {
            callback();
        } else {
            PresentationEditorController.hidePropertyPanel();
        }
    };

    render() {
        const { children, isChildElement, showCloseButton = true } = this.props;

        return (
            <StyledPropertyPanelHeader isChildElement={isChildElement}>
                {children}
                {showCloseButton && (
                    <>
                        <FlexSpacer />
                        <IconButton icon="close" onClick={this.handleClose} />
                    </>
                )}
            </StyledPropertyPanelHeader>
        );
    }
}

